const OverlayBurger = ({ isOpenMenu, setIsOpenMenu }: any) => {
  return (
    <div
      className={
        isOpenMenu ? "overlay-burger overlay-burger--opened" : "overlay-burger"
      }
      onClick={() => {
        setIsOpenMenu(!isOpenMenu)
      }}
    ></div>
  )
}

export default OverlayBurger
